import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Bar } from '../../atoms/Bar';
import { ReviewBarProps } from './ReviewBar.types';

export const ReviewBar = ({
  className,
  max,
  onFilterReviews,
  microcopy,
  review,
  value,
}: ReviewBarProps) => {
  const isClickable = review > 0;

  const content = (
    <>
      <span
        className={c(
          'w-14 whitespace-nowrap font-normal tabular-nums tracking-[-0.028px]',
          isClickable ? 'text-blue group-hover:underline' : 'text-grey-900'
        )}
      >
        {interpolateStringWithData(
          value !== 1 ? microcopy.ratings : microcopy.rating,
          { rating: value }
        )}
      </span>

      <Bar
        className="mx-3"
        value={review}
        max={max}
        aria-valuenow={review}
        aria-valuemax={max}
        ariaLabel={interpolateStringWithData(microcopy.ariaLabel, {
          review,
        })}
        renderInnerBar={review > 0}
      />

      <span
        className={c(
          'w-14 text-right tabular-nums tracking-[-0.028px]',
          isClickable ? 'text-blue group-hover:underline' : 'text-grey-450'
        )}
      >
        {review.toLocaleString()}
      </span>
    </>
  );

  if (isClickable) {
    const titleText = interpolateStringWithData(microcopy.ariaLabel, {
      review,
      max,
    });

    return (
      <button
        type="button"
        className={c(
          'group flex w-full cursor-pointer items-center text-left text-sm',
          className
        )}
        onClick={() => onFilterReviews(value)}
        aria-label={titleText}
        title={titleText}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={c('flex w-full items-center text-left text-sm', className)}>
      {content}
    </div>
  );
};
